<!--component html goes here -->

<!-- header old -->
<!-- <div class="header-left d-none">
  <a routerLink="dashboard" class="logo">
    <img src="../../../../assets/img/logo/logo.webp" alt="Logo" />
  </a>
  <a routerLink="dashboard" class="logo collapse-logo">
    <img src="../../../../assets/img/collapse-logo.svg" alt="Logo" />
  </a>
  <a routerLink="dashboard" class="logo2">
    <img src="../../../../assets/img/logo/logo-small.webp" width="40" height="40" alt="Logo" />
  </a>
</div> -->

<!-- <a id="toggle_btn" href="javascript:void(0);" (click)="toggleSidebar();" class="d-none">
    <span class="bar-icon">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </a> -->

<div class="page-title-box d-none">
  <h3>AVR HRMS</h3>
</div>

<a id="mobile_btn" class="mobile_btn d-none" href="#sidebar"><i class="fa-solid fa-bars"></i></a>

<ul class="nav user-menu d-none">
  <li class="nav-item d-none">
    <div class="top-nav-search">
      <a href="javascript:void(0);" class="responsive-search">
        <i class="fa-solid fa-magnifying-glass"></i>
      </a>
      <form id="search" action="https://avrtechno.com/html/template/search.html">
        <input class="form-control" type="text" placeholder="Search here" />
        <button class="btn" type="submit"><i class="fa-solid fa-magnifying-glass"></i></button>
      </form>
    </div>
  </li>

  <!-- <li class="nav-item dropdown has-arrow flag-nav d-none">
    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="javascript:void(0)" role="button">
      <img src="../../../../assets/img/flags/us.png" alt="Flag" height="20" /> <span>English</span>
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <a href="javascript:void(0);" class="dropdown-item">
        <img src="../../../../assets/img/flags/us.png" alt="Flag" height="16" /> English
      </a>
      <a href="javascript:void(0);" class="dropdown-item">
        <img src="../../../../assets/img/flags/fr.png" alt="Flag" height="16" /> French
      </a>
      <a href="javascript:void(0);" class="dropdown-item">
        <img src="../../../../assets/img/flags/es.png" alt="Flag" height="16" /> Spanish
      </a>
      <a href="javascript:void(0);" class="dropdown-item">
        <img src="../../../../assets/img/flags/de.png" alt="Flag" height="16" /> German
      </a>
    </div>
  </li>

  <li class="nav-item dropdown d-none">
    <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
      <i class="fa-regular fa-bell"></i> <span class="badge rounded-pill">3</span>
    </a>
    <div class="dropdown-menu notifications">
      <div class="topnav-dropdown-header">
        <span class="notification-title">Notifications</span>
        <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
      </div>
      <div class="noti-content">
        <ul class="notification-list">
          <li class="notification-message">
            <a href="activities.html">
              <div class="chat-block d-flex">
                <span class="avatar flex-shrink-0">
                  <img src="../../../../assets/img/profiles/avatar-02.jpg" alt="User Image" />
                </span>
                <div class="media-body flex-grow-1">
                  <p class="noti-details">
                    <span class="noti-title">John Doe</span> added new task
                    <span class="noti-title">Patient appointment booking</span>
                  </p>
                  <p class="noti-time"><span class="notification-time">4 mins ago</span></p>
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="activities.html">
              <div class="chat-block d-flex">
                <span class="avatar flex-shrink-0">
                  <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="User Image" />
                </span>
                <div class="media-body flex-grow-1">
                  <p class="noti-details">
                    <span class="noti-title">Tarah Shropshire</span> changed the task name
                    <span class="noti-title">Appointment booking with payment gateway</span>
                  </p>
                  <p class="noti-time"><span class="notification-time">6 mins ago</span></p>
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="activities.html">
              <div class="chat-block d-flex">
                <span class="avatar flex-shrink-0">
                  <img src="../../../../assets/img/profiles/avatar-06.jpg" alt="User Image" />
                </span>
                <div class="media-body flex-grow-1">
                  <p class="noti-details">
                    <span class="noti-title">Misty Tison</span> added
                    <span class="noti-title">Domenic Houston</span> and
                    <span class="noti-title">Claire Mapes</span> to project
                    <span class="noti-title">Doctor available module</span>
                  </p>
                  <p class="noti-time"><span class="notification-time">8 mins ago</span></p>
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="activities.html">
              <div class="chat-block d-flex">
                <span class="avatar flex-shrink-0">
                  <img src="../../../../assets/img/profiles/avatar-17.jpg" alt="User Image" />
                </span>
                <div class="media-body flex-grow-1">
                  <p class="noti-details">
                    <span class="noti-title">Rolland Webber</span> completed task
                    <span class="noti-title">Patient and Doctor video conferencing</span>
                  </p>
                  <p class="noti-time"><span class="notification-time">12 mins ago</span></p>
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="activities.html">
              <div class="chat-block d-flex">
                <span class="avatar flex-shrink-0">
                  <img src="../../../../assets/img/profiles/avatar-13.jpg" alt="User Image" />
                </span>
                <div class="media-body flex-grow-1">
                  <p class="noti-details">
                    <span class="noti-title">Bernardo Galaviz</span> added new task
                    <span class="noti-title">Private chat module</span>
                  </p>
                  <p class="noti-time"><span class="notification-time">2 days ago</span></p>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="topnav-dropdown-footer">
        <a href="activities.html">View all Notifications</a>
      </div>
    </div>
  </li>

  <li class="nav-item dropdown d-none">
    <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
      <i class="fa-regular fa-comment"></i><span class="badge rounded-pill">8</span>
    </a>
    <div class="dropdown-menu notifications">
      <div class="topnav-dropdown-header">
        <span class="notification-title">Messages</span>
        <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
      </div>
      <div class="noti-content">
        <ul class="notification-list">
          <li class="notification-message">
            <a href="chat.html">
              <div class="list-item">
                <div class="list-left">
                  <span class="avatar">
                    <img src="../../../../assets/img/profiles/avatar-09.jpg" alt="User Image" />
                  </span>
                </div>
                <div class="list-body">
                  <span class="message-author">Richard Miles </span>
                  <span class="message-time">12:28 AM</span>
                  <div class="clearfix"></div>
                  <span class="message-content"
                    >Lorem ipsum dolor sit amet, consectetur adipiscing</span
                  >
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="chat.html">
              <div class="list-item">
                <div class="list-left">
                  <span class="avatar">
                    <img src="../../../../assets/img/profiles/avatar-02.jpg" alt="User Image" />
                  </span>
                </div>
                <div class="list-body">
                  <span class="message-author">John Doe</span>
                  <span class="message-time">6 Mar</span>
                  <div class="clearfix"></div>
                  <span class="message-content"
                    >Lorem ipsum dolor sit amet, consectetur adipiscing</span
                  >
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="chat.html">
              <div class="list-item">
                <div class="list-left">
                  <span class="avatar">
                    <img src="../../../../assets/img/profiles/avatar-03.jpg" alt="User Image" />
                  </span>
                </div>
                <div class="list-body">
                  <span class="message-author"> Tarah Shropshire </span>
                  <span class="message-time">5 Mar</span>
                  <div class="clearfix"></div>
                  <span class="message-content"
                    >Lorem ipsum dolor sit amet, consectetur adipiscing</span
                  >
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="chat.html">
              <div class="list-item">
                <div class="list-left">
                  <span class="avatar">
                    <img src="../../../../assets/img/profiles/avatar-05.jpg" alt="User Image" />
                  </span>
                </div>
                <div class="list-body">
                  <span class="message-author">Mike Litorus</span>
                  <span class="message-time">3 Mar</span>
                  <div class="clearfix"></div>
                  <span class="message-content"
                    >Lorem ipsum dolor sit amet, consectetur adipiscing</span
                  >
                </div>
              </div>
            </a>
          </li>
          <li class="notification-message">
            <a href="chat.html">
              <div class="list-item">
                <div class="list-left">
                  <span class="avatar">
                    <img src="../../../../assets/img/profiles/avatar-08.jpg" alt="User Image" />
                  </span>
                </div>
                <div class="list-body">
                  <span class="message-author"> Catherine Manseau </span>
                  <span class="message-time">27 Feb</span>
                  <div class="clearfix"></div>
                  <span class="message-content"
                    >Lorem ipsum dolor sit amet, consectetur adipiscing</span
                  >
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="topnav-dropdown-footer">
        <a href="chat.html">View all Messages</a>
      </div>
    </div>
  </li> -->

  <li class="nav-item dropdown has-arrow main-drop">
    <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
      <!-- <span class="user-img"><img src="../../../../assets/img/avatar/avatar-27.jpg" alt="User Image"> </span> -->
      <span class="user-img">
        <!-- <img [src]="" alt="User Image" *ngIf="user" /> -->
        <img [src]="userPicture" class="rounded-circle border border-2" alt="img" />
        <span class="status online"></span
      ></span>

      <span>{{ user?.firstName }}</span>
    </a>
    <div class="dropdown-menu">
      <a class="dropdown-item" href="profile.html">My Profile</a>
      <a class="dropdown-item" href="settings.html">Settings</a>
      <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
    </div>
  </li>
</ul>

<div class="dropdown mobile-user-menu d-none">
  <a
    href="javascript:void(0)"
    class="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    ><i class="fa-solid fa-ellipsis-vertical"></i
  ></a>
  <div class="dropdown-menu dropdown-menu-right">
    <a class="dropdown-item" href="profile.html">My Profile</a>
    <a class="dropdown-item" href="settings.html">Settings</a>
    <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
  </div>
</div>
<!-- header old end -->

<!-- header new -->
<!-- Header -->
<div class="header">
  <div class="main-header d-flex align-items-center justify-content-between">
    <div class="header-left">
      <a [routerLink]="[getDashboardRoute()]" class="logo">
        <img src="assets/img/logo/logo.webp" alt="Logo" />
      </a>
      <a [routerLink]="[getDashboardRoute()]" class="dark-logo">
        <img src="assets/img/logo/logo-white.webp" alt="Logo" />
      </a>
    </div>
    <!-- CENTER (Activation Link) -->
    <div class="header-center text-center flex-grow-1">
      <a
        id="mobile_btn"
        class="mobile_btn"
        href="javascript:void(0);"
        (click)="toggleSidebar($event)"
      >
        <span class="bar-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>
      <!-- <a
        *ngIf="showActivationLink"
        style="
          position: absolute;
          left: 50%;
          top: 25%;
          transform: translateX(-50%);
          white-space: nowrap;
          z-index: 10;
          color: #ff0000;
        "
        href="javascript:void(0)"
        (click)="redirectToBilling()"
        >Activate your subscription!
        <span *ngIf="trialDaysRemaining !== null">
          {{ trialMessage }}
        </span></a
      > -->
      <!-- <a
        *ngIf="showActivationLink"
        style="top: 25%; white-space: nowrap; z-index: 10; color: #ff0000"
        href="javascript:void(0)"
        (click)="redirectToBilling()"
        >Activate your subscription!
        <span *ngIf="trialDaysRemaining !== null">
          {{ trialMessage }}
        </span></a
      > -->
    </div>
    <div class="header-user">
      <!-- <span
        class="avatar avatar-lg rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white ms-2"
        style="width: 32px; height: 32px"
      >
        <ng-container *ngIf="businessimageObjectURL; else businessinitials">
          <img
            [src]="businessimageObjectURL"
            alt="Img"
            class="img-fluid rounded-circle w-100 h-100 object-fit-cover"
          />
        </ng-container>
        <ng-template #businessinitials>
          {{ getInitials(user?.business?.businessName) }}
        </ng-template>
      </span>
      <span
        class="badge bg-info rounded-pill text-center me-4 ms-2 mt-2 centered-badge"
        *ngIf="user?.business?.businessName; else noBusiness"
      >
        {{ user?.business?.businessName | capitalize }}
      </span>
      <ng-template #noBusiness>
        <span
          class="badge bg-info rounded-pill d-flex align-items-center justify-content-center me-4"
        >
          N/A
        </span>
      </ng-template> -->
      <div class="nav user-menu nav-list">
        <div class="me-auto d-flex align-items-center" id="header-search">
          <!-- <a id="toggle_btn" href="javascript:void(0);" class="btn btn-menubar me-1">
              <i class="ti ti-arrow-bar-to-left"></i>
            </a> -->
          <!-- Search -->
          <div class="input-group input-group-flat d-inline-flex me-1 d-none">
            <span class="input-icon-addon">
              <i class="ti ti-search"></i>
            </span>
            <input type="text" class="form-control" placeholder="Search in HRMS" />
            <!-- <span class="input-group-text">
                <kbd>CTRL + / </kbd>
              </span> -->
          </div>
          <!-- /Search -->
          <div class="dropdown crm-dropdown d-none">
            <a href="javascript:void(0)" class="btn btn-menubar me-1" data-bs-toggle="dropdown">
              <i class="ti ti-layout-grid"></i>
            </a>
            <div class="dropdown-menu dropdown-lg dropdown-menu-start">
              <div class="card mb-0 border-0 shadow-none">
                <div class="card-header">
                  <h4>CRM</h4>
                </div>
                <div class="card-body pb-1">
                  <div class="row">
                    <div class="col-sm-6">
                      <a
                        href="contacts.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-user-shield text-default me-2"></i>Contacts
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                      <a
                        href="deals-grid.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-heart-handshake text-default me-2"></i>Deals
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                      <a
                        href="pipeline.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-timeline-event-text text-default me-2"></i>Pipeline
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                    </div>
                    <div class="col-sm-6">
                      <a
                        href="companies-grid.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-building text-default me-2"></i>Companies
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                      <a
                        href="leads-grid.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-user-check text-default me-2"></i>Leads
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                      <a
                        href="activity.html"
                        class="d-flex align-items-center justify-content-between p-2 crm-link mb-3"
                      >
                        <span class="d-flex align-items-center me-3">
                          <i class="ti ti-activity text-default me-2"></i>Activities
                        </span>
                        <i class="ti ti-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a href="profile-settings.html" class="btn btn-menubar d-none">
            <i class="ti ti-settings-cog"></i>
          </a>
        </div>

        <!-- Horizontal Single -->
        <!-- <div class="sidebar sidebar-horizontal" id="horizontal-single">
            <div class="sidebar-menu">
              <div class="main-menu">
                <ul class="nav-menu">
                  <li class="menu-title">
                    <span>Main</span>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)" class="active">
                      <i class="ti ti-smart-home"></i><span>Dashboard</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li><a href="index.html" class="active">Admin Dashboard</a></li>
                      <li><a href="employee-dashboard.html">Employee Dashboard</a></li>
                      <li><a href="deals-dashboard.html">Deals Dashboard</a></li>
                      <li><a href="leads-dashboard.html">Leads Dashboard</a></li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-user-star"></i><span>Super Admin</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li><a href="dashboard.html">Dashboard</a></li>
                      <li><a href="companies.html">Companies</a></li>
                      <li><a href="subscription.html">Subscriptions</a></li>
                      <li><a href="packages.html">Packages</a></li>
                      <li><a href="domain.html">Domain</a></li>
                      <li><a href="purchase-transaction.html">Purchase Transaction</a></li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-layout-grid-add"></i><span>Applications</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li><a href="chat.html">Chat</a></li>
                      <li class="submenu submenu-two">
                        <a href="call.html">Calls<span
                            class="menu-arrow inside-submenu"></span></a>
                        <ul>
                          <li><a href="voice-call.html">Voice Call</a></li>
                          <li><a href="video-call.html">Video Call</a></li>
                          <li><a href="outgoing-call.html">Outgoing Call</a></li>
                          <li><a href="incoming-call.html">Incoming Call</a></li>
                          <li><a href="call-history.html">Call History</a></li>
                        </ul>
                      </li>
                      <li><a href="calendar.html">Calendar</a></li>
                      <li><a href="email.html">Email</a></li>
                      <li><a href="todo.html">To Do</a></li>
                      <li><a href="notes.html">Notes</a></li>
                      <li><a href="file-manager.html">File Manager</a></li>
                      <li><a href="kanban-view.html">Kanban</a></li>
                      <li><a href="invoices.html">Invoices</a></li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-layout-board-split"></i><span>Layouts</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li>
                        <a href="layout-horizontal.html">
                          <span>Horizontal</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-detached.html">
                          <span>Detached</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-modern.html">
                          <span>Modern</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-two-column.html">
                          <span>Two Column </span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-hovered.html">
                          <span>Hovered</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-box.html">
                          <span>Boxed</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-horizontal-single.html">
                          <span>Horizontal Single</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-horizontal-overlay.html">
                          <span>Horizontal Overlay</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-horizontal-box.html">
                          <span>Horizontal Box</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-horizontal-sidemenu.html">
                          <span>Menu Aside</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-vertical-transparent.html">
                          <span>Transparent</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-without-header.html">
                          <span>Without Header</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-rtl.html">
                          <span>RTL</span>
                        </a>
                      </li>
                      <li>
                        <a href="layout-dark.html">
                          <span>Dark</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-user-star"></i><span>Projects</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li>
                        <a href="clients-grid.html"><span>Clients</span>
                        </a>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Projects</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="projects-grid.html">Projects</a></li>
                          <li><a href="tasks.html">Tasks</a></li>
                          <li><a href="task-board.html">Task Board</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="call.html">Crm<span class="menu-arrow"></span></a>
                        <ul>
                          <li><a href="contacts-grid.html"><span>Contacts</span></a></li>
                          <li><a href="companies-grid.html"><span>Companies</span></a></li>
                          <li><a href="deals-grid.html"><span>Deals</span></a></li>
                          <li><a href="leads-grid.html"><span>Leads</span></a></li>
                          <li><a href="pipeline.html"><span>Pipeline</span></a></li>
                          <li><a href="analytics.html"><span>Analytics</span></a></li>
                          <li><a href="activity.html"><span>Activities</span></a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Employees</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="employees.html">Employee Lists</a></li>
                          <li><a href="employees-grid.html">Employee Grid</a></li>
                          <li><a href="employee-details.html">Employee Details</a></li>
                          <li><a href="departments.html">Departments</a></li>
                          <li><a href="designations.html">Designations</a></li>
                          <li><a href="policy.html">Policies</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Tickets</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="tickets.html">Tickets</a></li>
                          <li><a href="ticket-details.html">Ticket Details</a></li>
                        </ul>
                      </li>
                      <li><a href="holidays.html"><span>Holidays</span></a></li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Attendance</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li class="submenu">
                            <a href="javascript:void(0);">Leaves<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="leaves.html">Leaves (Admin)</a></li>
                              <li><a href="leaves-employee.html">Leave (Employee)</a></li>
                              <li><a href="leave-settings.html">Leave Settings</a></li>
                            </ul>
                          </li>
                          <li><a href="attendance-admin.html">Attendance (Admin)</a></li>
                          <li><a href="attendance-employee.html">Attendance (Employee)</a></li>
                          <li><a href="timesheets.html">Timesheets</a></li>
                          <li><a href="schedule-timing.html">Shift & Schedule</a></li>
                          <li><a href="overtime.html">Overtime</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Performance</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="performance-indicator.html">Performance Indicator</a></li>
                          <li><a href="performance-review.html">Performance Review</a></li>
                          <li><a href="performance-appraisal.html">Performance Appraisal</a></li>
                          <li><a href="goal-tracking.html">Goal List</a></li>
                          <li><a href="goal-type.html">Goal Type</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Training</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="training.html">Training List</a></li>
                          <li><a href="trainers.html">Trainers</a></li>
                          <li><a href="training-type.html">Training Type</a></li>
                        </ul>
                      </li>
                      <li><a href="promotion.html"><span>Promotion</span></a></li>
                      <li><a href="resignation.html"><span>Resignation</span></a></li>
                      <li><a href="termination.html"><span>Termination</span></a></li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-user-star"></i><span>Administration</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Sales</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="estimates.html">Estimates</a></li>
                          <li><a href="invoices.html">Invoices</a></li>
                          <li><a href="payments.html">Payments</a></li>
                          <li><a href="expenses.html">Expenses</a></li>
                          <li><a href="provident-fund.html">Provident Fund</a></li>
                          <li><a href="taxes.html">Taxes</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Accounting</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="categories.html">Categories</a></li>
                          <li><a href="budgets.html">Budgets</a></li>
                          <li><a href="budget-expenses.html">Budget Expenses</a></li>
                          <li><a href="budget-revenues.html">Budget Revenues</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Payroll</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="employee-salary.html">Employee Salary</a></li>
                          <li><a href="payslip.html">Payslip</a></li>
                          <li><a href="payroll.html">Payroll Items</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Assets</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="assets.html">Assets</a></li>
                          <li><a href="asset-categories.html">Asset Categories</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Help & Supports</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="knowledgebase.html">Knowledge Base</a></li>
                          <li><a href="activity.html">Activities</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>User Management</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="users.html">Users</a></li>
                          <li><a href="roles-permissions.html">Roles & Permissions</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Reports</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li><a href="expenses-report.html">Expense Report</a></li>
                          <li><a href="invoice-report.html">Invoice Report</a></li>
                          <li><a href="payment-report.html">Payment Report</a></li>
                          <li><a href="project-report.html">Project Report</a></li>
                          <li><a href="task-report.html">Task Report</a></li>
                          <li><a href="user-report.html">User Report</a></li>
                          <li><a href="employee-report.html">Employee Report</a></li>
                          <li><a href="payslip-report.html">Payslip Report</a></li>
                          <li><a href="attendance-report.html">Attendance Report</a></li>
                          <li><a href="leave-report.html">Leave Report</a></li>
                          <li><a href="daily-report.html">Daily Report</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Settings</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li class="submenu">
                            <a href="javascript:void(0);">General Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="profile-settings.html">Profile</a></li>
                              <li><a href="security-settings.html">Security</a></li>
                              <li><a href="notification-settings.html">Notifications</a></li>
                              <li><a href="connected-apps.html">Connected Apps</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Website Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="bussiness-settings.html">Business Settings</a></li>
                              <li><a href="seo-settings.html">SEO Settings</a></li>
                              <li><a href="localization-settings.html">Localization</a></li>
                              <li><a href="prefixes.html">Prefixes</a></li>
                              <li><a href="preferences.html">Preferences</a></li>
                              <li><a href="performance-appraisal.html">Appearance</a></li>
                              <li><a href="language.html">Language</a></li>
                              <li><a href="authentication-settings.html">Authentication</a></li>
                              <li><a href="ai-settings.html">AI Settings</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">App Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="salary-settings.html">Salary Settings</a></li>
                              <li><a href="approval-settings.html">Approval Settings</a></li>
                              <li><a href="invoice-settings.html">Invoice Settings</a></li>
                              <li><a href="leave-type.html">Leave Type</a></li>
                              <li><a href="custom-fields.html">Custom Fields</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">System Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="email-settings.html">Email Settings</a></li>
                              <li><a href="email-template.html">Email Templates</a></li>
                              <li><a href="sms-settings.html">SMS Settings</a></li>
                              <li><a href="sms-template.html">SMS Templates</a></li>
                              <li><a href="otp-settings.html">OTP</a></li>
                              <li><a href="gdpr.html">GDPR Cookies</a></li>
                              <li><a href="maintenance-mode.html">Maintenance Mode</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Financial Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="payment-gateways.html">Payment Gateways</a></li>
                              <li><a href="tax-rates.html">Tax Rate</a></li>
                              <li><a href="currencies.html">Currencies</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Other Settings<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="custom-css.html">Custom CSS</a></li>
                              <li><a href="custom-js.html">Custom JS</a></li>
                              <li><a href="cronjob.html">Cronjob</a></li>
                              <li><a href="storage-settings.html">Storage</a></li>
                              <li><a href="ban-ip-address.html">Ban IP Address</a></li>
                              <li><a href="backup.html">Backup</a></li>
                              <li><a href="clear-cache.html">Clear Cache</a></li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="javascript:void(0)">
                      <i class="ti ti-page-break"></i><span>Pages</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li><a href="starter.html"><span>Starter</span></a></li>
                      <li><a href="profile.html"><span>Profile</span></a></li>
                      <li><a href="gallery.html"><span>Gallery</span></a></li>
                      <li><a href="search-result.html"><span>Search Results</span></a></li>
                      <li><a href="timeline.html"><span>Timeline</span></a></li>
                      <li><a href="pricing.html"><span>Pricing</span></a></li>
                      <li><a href="coming-soon.html"><span>Coming Soon</span></a></li>
                      <li><a href="under-maintenance.html"><span>Under Maintenance</span></a></li>
                      <li><a href="under-construction.html"><span>Under Construction</span></a></li>
                      <li><a href="api-keys.html"><span>API Keys</span></a></li>
                      <li><a href="privacy-policy.html"><span>Privacy Policy</span></a></li>
                      <li><a href="terms-condition.html"><span>Terms & Conditions</span></a></li>
                      <li class="submenu">
                        <a href="javascript:void(0)"><span>Content</span> <span class="menu-arrow"></span></a>
                        <ul>
                          <li><a href="pages.html">Pages</a></li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Blogs<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="blogs.html">All Blogs</a></li>
                              <li><a href="blog-categories.html">Categories</a></li>
                              <li><a href="blog-comments.html">Comments</a></li>
                              <li><a href="blog-tags.html">Tags</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Locations<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="countries.html">Countries</a></li>
                              <li><a href="states.html">States</a></li>
                              <li><a href="cities.html">Cities</a></li>
                            </ul>
                          </li>
                          <li><a href="testimonials.html">Testimonials</a></li>
                          <li><a href="faq.html">FAQ’S</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0)">
                          <span>Authentication</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li class="submenu">
                            <a href="javascript:void(0);" class="">Login<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="login.html">Cover</a></li>
                              <li><a href="login-2.html">Illustration</a></li>
                              <li><a href="login-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);" class="">Register<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="register.html">Cover</a></li>
                              <li><a href="register-2.html">Illustration</a></li>
                              <li><a href="register-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li class="submenu"><a href="javascript:void(0);">Forgot Password<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="forgot-password.html">Cover</a></li>
                              <li><a href="forgot-password-2.html">Illustration</a></li>
                              <li><a href="forgot-password-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Reset Password<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="reset-password.html">Cover</a></li>
                              <li><a href="reset-password-2.html">Illustration</a></li>
                              <li><a href="reset-password-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">Email Verification<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="email-verification.html">Cover</a></li>
                              <li><a href="email-verification-2.html">Illustration</a></li>
                              <li><a href="email-verification-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">2 Step Verification<span class="menu-arrow"></span></a>
                            <ul>
                              <li><a href="two-step-verification.html">Cover</a></li>
                              <li><a href="two-step-verification-2.html">Illustration</a></li>
                              <li><a href="two-step-verification-3.html">Basic</a></li>
                            </ul>
                          </li>
                          <li><a href="lock-screen.html">Lock Screen</a></li>
                          <li><a href="error-404.html">404 Error</a></li>
                          <li><a href="error-500.html">500 Error</a></li>
                        </ul>
                      </li>
                      <li class="submenu">
                        <a href="javascript:void(0)">
                          <span>UI Interface</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-hierarchy-2"></i>
                              <span>Base UI</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="ui-alerts.html">Alerts</a>
                              </li>
                              <li>
                                <a href="ui-accordion.html">Accordion</a>
                              </li>
                              <li>
                                <a href="ui-avatar.html">Avatar</a>
                              </li>
                              <li>
                                <a href="ui-badges.html">Badges</a>
                              </li>
                              <li>
                                <a href="ui-borders.html">Border</a>
                              </li>
                              <li>
                                <a href="ui-buttons.html">Buttons</a>
                              </li>
                              <li>
                                <a href="ui-buttons-group.html">Button Group</a>
                              </li>
                              <li>
                                <a href="ui-breadcrumb.html">Breadcrumb</a>
                              </li>
                              <li>
                                <a href="ui-cards.html">Card</a>
                              </li>
                              <li>
                                <a href="ui-carousel.html">Carousel</a>
                              </li>
                              <li>
                                <a href="ui-colors.html">Colors</a>
                              </li>
                              <li>
                                <a href="ui-dropdowns.html">Dropdowns</a>
                              </li>
                              <li>
                                <a href="ui-grid.html">Grid</a>
                              </li>
                              <li>
                                <a href="ui-images.html">Images</a>
                              </li>
                              <li>
                                <a href="ui-lightbox.html">Lightbox</a>
                              </li>
                              <li>
                                <a href="ui-media.html">Media</a>
                              </li>
                              <li>
                                <a href="ui-modals.html">Modals</a>
                              </li>
                              <li>
                                <a href="ui-offcanvas.html">Offcanvas</a>
                              </li>
                              <li>
                                <a href="ui-pagination.html">Pagination</a>
                              </li>
                              <li>
                                <a href="ui-popovers.html">Popovers</a>
                              </li>
                              <li>
                                <a href="ui-progress.html">Progress</a>
                              </li>
                              <li>
                                <a href="ui-placeholders.html">Placeholders</a>
                              </li>
                              <li>
                                <a href="ui-spinner.html">Spinner</a>
                              </li>
                              <li>
                                <a href="ui-sweetalerts.html">Sweet Alerts</a>
                              </li>
                              <li>
                                <a href="ui-nav-tabs.html">Tabs</a>
                              </li>
                              <li>
                                <a href="ui-toasts.html">Toasts</a>
                              </li>
                              <li>
                                <a href="ui-tooltips.html">Tooltips</a>
                              </li>
                              <li>
                                <a href="ui-typography.html">Typography</a>
                              </li>
                              <li>
                                <a href="ui-video.html">Video</a>
                              </li>
                              <li>
                                <a href="ui-sortable.html">Sortable</a>
                              </li>
                              <li>
                                <a href="ui-swiperjs.html">Swiperjs</a>
                              </li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-hierarchy-3"></i>
                              <span>Advanced UI</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="ui-ribbon.html">Ribbon</a>
                              </li>
                              <li>
                                <a href="ui-clipboard.html">Clipboard</a>
                              </li>
                              <li>
                                <a href="ui-drag-drop.html">Drag & Drop</a>
                              </li>
                              <li>
                                <a href="ui-rangeslider.html">Range Slider</a>
                              </li>
                              <li>
                                <a href="ui-rating.html">Rating</a>
                              </li>
                              <li>
                                <a href="ui-text-editor.html">Text Editor</a>
                              </li>
                              <li>
                                <a href="ui-counter.html">Counter</a>
                              </li>
                              <li>
                                <a href="ui-scrollbar.html">Scrollbar</a>
                              </li>
                              <li>
                                <a href="ui-stickynote.html">Sticky Note</a>
                              </li>
                              <li>
                                <a href="ui-timeline.html">Timeline</a>
                              </li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-input-search"></i>
                              <span>Forms</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li class="submenu submenu-two">
                                <a href="javascript:void(0);">Form Elements <span class="menu-arrow inside-submenu"></span>
                                </a>
                                <ul>
                                  <li>
                                    <a href="form-basic-inputs.html">Basic Inputs</a>
                                  </li>
                                  <li>
                                    <a href="form-checkbox-radios.html">Checkbox & Radios</a>
                                  </li>
                                  <li>
                                    <a href="form-input-groups.html">Input Groups</a>
                                  </li>
                                  <li>
                                    <a href="form-grid-gutters.html">Grid & Gutters</a>
                                  </li>
                                  <li>
                                    <a href="form-select.html">Form Select</a>
                                  </li>
                                  <li>
                                    <a href="form-mask.html">Input Masks</a>
                                  </li>
                                  <li>
                                    <a href="form-fileupload.html">File Uploads</a>
                                  </li>
                                </ul>
                              </li>
                              <li class="submenu submenu-two">
                                <a href="javascript:void(0);">Layouts <span class="menu-arrow inside-submenu"></span>
                                </a>
                                <ul>
                                  <li>
                                    <a href="form-horizontal.html">Horizontal Form</a>
                                  </li>
                                  <li>
                                    <a href="form-vertical.html">Vertical Form</a>
                                  </li>
                                  <li>
                                    <a href="form-floating-labels.html">Floating Labels</a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a href="form-validation.html">Form Validation</a>
                              </li>
  
                              <li>
                                <a href="form-select2.html">Select2</a>
                              </li>
                              <li>
                                <a href="form-wizard.html">Form Wizard</a>
                              </li>
                              <li>
                                <a href="form-pickers.html">Form Pickers</a>
                              </li>
  
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-table-plus"></i>
                              <span>Tables</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="tables-basic.html">Basic Tables </a>
                              </li>
                              <li>
                                <a href="data-tables.html">Data Table </a>
                              </li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-chart-line"></i>
                              <span>Charts</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="chart-apex.html">Apex Charts</a>
                              </li>
                              <li>
                                <a href="chart-c3.html">Chart C3</a>
                              </li>
                              <li>
                                <a href="chart-js.html">Chart Js</a>
                              </li>
                              <li>
                                <a href="chart-morris.html">Morris Charts</a>
                              </li>
                              <li>
                                <a href="chart-flot.html">Flot Charts</a>
                              </li>
                              <li>
                                <a href="chart-peity.html">Peity Charts</a>
                              </li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-icons"></i>
                              <span>Icons</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="icon-fontawesome.html">Fontawesome Icons</a>
                              </li>
                              <li>
                                <a href="icon-tabler.html">Tabler Icons</a>
                              </li>
                              <li>
                                <a href="icon-bootstrap.html">Bootstrap Icons</a>
                              </li>
                              <li>
                                <a href="icon-remix.html">Remix Icons</a>
                              </li>
                              <li>
                                <a href="icon-feather.html">Feather Icons</a>
                              </li>
                              <li>
                                <a href="icon-ionic.html">Ionic Icons</a>
                              </li>
                              <li>
                                <a href="icon-material.html">Material Icons</a>
                              </li>
                              <li>
                                <a href="icon-pe7.html">Pe7 Icons</a>
                              </li>
                              <li>
                                <a href="icon-simpleline.html">Simpleline Icons</a>
                              </li>
                              <li>
                                <a href="icon-themify.html">Themify Icons</a>
                              </li>
                              <li>
                                <a href="icon-weather.html">Weather Icons</a>
                              </li>
                              <li>
                                <a href="icon-typicon.html">Typicon Icons</a>
                              </li>
                              <li>
                                <a href="icon-flag.html">Flag Icons</a>
                              </li>
                            </ul>
                          </li>
                          <li class="submenu">
                            <a href="javascript:void(0);">
                              <i class="ti ti-table-plus"></i>
                              <span>Maps</span>
                              <span class="menu-arrow"></span>
                            </a>
                            <ul>
                              <li>
                                <a href="maps-vector.html">Vector</a>
                              </li>
                              <li>
                                <a href="maps-leaflet.html">Leaflet</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li><a href="javascript:void(0)">Documentation</a></li>
                      <li><a href="javascript:void(0)">Change Log</a></li>
                      <li class="submenu">
                        <a href="javascript:void(0);"><span>Multi Level</span><span class="menu-arrow"></span></a>
                        <ul>
                          <li><a href="javascript:void(0);">Multilevel 1</a></li>
                          <li class="submenu submenu-two">
                            <a href="javascript:void(0);">Multilevel 2<span class="menu-arrow inside-submenu"></span></a>
                            <ul>
                              <li><a href="javascript:void(0);">Multilevel 2.1</a></li>
                              <li class="submenu submenu-two submenu-three">
                                <a href="javascript:void(0);">Multilevel 2.2<span class="menu-arrow inside-submenu inside-submenu-two"></span></a>
                                <ul>
                                  <li><a href="javascript:void(0);">Multilevel 2.2.1</a></li>
                                  <li><a href="javascript:void(0);">Multilevel 2.2.2</a></li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          <li><a href="javascript:void(0);">Multilevel 3</a></li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div> -->
        <!-- /Horizontal Single -->

        <div class="d-flex align-items-center">
          <div class="me-1 d-none">
            <a href="javascript:void(0)" class="btn btn-menubar btnFullscreen">
              <i class="ti ti-maximize"></i>
            </a>
          </div>
          <div class="dropdown me-1 d-none">
            <a href="javascript:void(0)" class="btn btn-menubar" data-bs-toggle="dropdown">
              <i class="ti ti-layout-grid-remove"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <div class="card mb-0 border-0 shadow-none">
                <div class="card-header">
                  <h4>Applications</h4>
                </div>
                <div class="card-body">
                  <a href="calendar.html" class="d-block pb-2">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-calendar text-gray-9"></i></span
                    >Calendar
                  </a>
                  <a href="todo.html" class="d-block py-2">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-subtask text-gray-9"></i></span
                    >To Do
                  </a>
                  <a href="notes.html" class="d-block py-2">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-notes text-gray-9"></i></span
                    >Notes
                  </a>
                  <a href="file-manager.html" class="d-block py-2">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-folder text-gray-9"></i></span
                    >File Manager
                  </a>
                  <a href="kanban-view.html" class="d-block py-2">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-layout-kanban text-gray-9"></i></span
                    >Kanban
                  </a>
                  <a href="invoices.html" class="d-block py-2 pb-0">
                    <span class="avatar avatar-md bg-transparent-dark me-2"
                      ><i class="ti ti-file-invoice text-gray-9"></i></span
                    >Invoices
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="me-1 d-none">
            <a href="chat.html" class="btn btn-menubar position-relative">
              <i class="ti ti-brand-hipchat"></i>
              <span
                class="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
                >5</span
              >
            </a>
          </div>
          <div class="me-1 d-none">
            <a href="email.html" class="btn btn-menubar">
              <i class="ti ti-mail"></i>
            </a>
          </div>
          <!-- <div class="me-1 notification_item">
            <a
              href="javascript:void(0)"
              class="btn btn-menubar position-relative me-1"
              id="notification_popup"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-bell"></i>
              <span class="notification-status-dot"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-end notification-dropdown p-4">
              <div
                class="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3"
              >
                <h4 class="notification-title">Notifications (2)</h4>
                <div class="d-flex align-items-center">
                  <a href="javascript:void(0)" class="text-primary fs-15 me-3 lh-1"
                    >Mark all as read</a
                  >
                  <div class="dropdown">
                    <a
                      href="javascript:void(0);"
                      class="bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i class="ti ti-calendar-due me-1"></i>Today
                    </a>
                    <ul class="dropdown-menu mt-2 p-3">
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          This Week
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          Last Week
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          Last Month
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="noti-content">
                <div class="d-flex flex-column">
                  <div class="border-bottom mb-3 pb-3">
                    <a href="activity.html">
                      <div class="d-flex">
                        <span class="avatar avatar-lg me-2 flex-shrink-0">
                          <img src="assets/img/profiles/avatar-27.jpg" alt="Profile" />
                        </span>
                        <div class="flex-grow-1">
                          <p class="mb-1">
                            <span class="text-dark fw-semibold">Shawn</span> performance in Math is
                            below the threshold.
                          </p>
                          <span>Just Now</span>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="border-bottom mb-3 pb-3">
                    <a href="activity.html" class="pb-0">
                      <div class="d-flex">
                        <span class="avatar avatar-lg me-2 flex-shrink-0">
                          <img src="assets/img/profiles/avatar-23.jpg" alt="Profile" />
                        </span>
                        <div class="flex-grow-1">
                          <p class="mb-1">
                            <span class="text-dark fw-semibold">Sylvia</span> added appointment on
                            02:00 PM
                          </p>
                          <span>10 mins ago</span>
                          <div class="d-flex justify-content-start align-items-center mt-1">
                            <span class="btn btn-light btn-sm me-2">Deny</span>
                            <span class="btn btn-primary btn-sm">Approve</span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="border-bottom mb-3 pb-3">
                    <a href="activity.html">
                      <div class="d-flex">
                        <span class="avatar avatar-lg me-2 flex-shrink-0">
                          <img src="assets/img/profiles/avatar-25.jpg" alt="Profile" />
                        </span>
                        <div class="flex-grow-1">
                          <p class="mb-1">
                            New student record <span class="text-dark fw-semibold"> George</span> is
                            created by <span class="text-dark fw-semibold">Teressa</span>
                          </p>
                          <span>2 hrs ago</span>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="border-0 mb-3 pb-0">
                    <a href="activity.html">
                      <div class="d-flex">
                        <span class="avatar avatar-lg me-2 flex-shrink-0">
                          <img src="assets/img/profiles/avatar-01.jpg" alt="Profile" />
                        </span>
                        <div class="flex-grow-1">
                          <p class="mb-1">
                            A new teacher record for
                            <span class="text-dark fw-semibold">Elisa</span>
                          </p>
                          <span>09:45 AM</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="d-flex p-0">
                <a href="javascript:void(0)" class="btn btn-light w-100 me-2">Cancel</a>
                <a href="activity.html" class="btn btn-primary w-100">View All</a>
              </div>
            </div>
          </div> -->
          <div class="me-1 notification_item">
            <a
              href="javascript:void(0)"
              class="btn btn-menubar position-relative me-1"
              id="notification_popup"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-bell"></i>
              <span class="notification-status-dot" *ngIf="hasUnreadNotifications"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-end notification-dropdown p-4">
              <div
                class="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3"
              >
                <h4 class="notification-title">Notifications</h4>
                <div class="d-flex align-items-center">
                  <!-- <a href="javascript:void(0)" class="text-primary fs-15 me-3 lh-1"
                    >Mark all as read</a
                  > -->
                  <div class="dropdown">
                    <a
                      href="javascript:void(0);"
                      class="bg-white dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <!-- <i class="ti ti-calendar-due me-1"></i>Today -->
                    </a>
                    <ul class="dropdown-menu mt-2 p-3">
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          This Week
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          Last Week
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item rounded-1">
                          Last Month
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="noti-content">
                <ng-container *ngIf="notifications.length > 0; else noHeaderNotifications">
                  <div class="d-flex flex-column">
                    <div class="border-bottom mb-3 pb-3" *ngFor="let notification of notifications">
                      <a href="javascript:void(0)" (click)="handleNotificationClick(notification)">
                        <div class="d-flex">
                          <!-- <span class="avatar avatar-lg me-2 flex-shrink-0">
                            <img src="assets/img/profiles/avatar-01.jpg" alt="Profile" />
                          </span> -->

                          <div class="flex-grow-1">
                            <p class="mb-1 fw-semibold">
                              {{ notification.title }}
                            </p>

                            <p class="mb-1 text-muted">
                              {{ notification.message }}
                            </p>

                            <span class="text-muted">
                              {{ notification.createdAt | date: 'short' }}
                            </span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </ng-container>

                <ng-template #noHeaderNotifications>
                  <div class="text-center py-3">No notifications</div>
                </ng-template>
              </div>
              <div class="d-flex p-0">
                <a href="javascript:void(0)" class="btn btn-light w-100 me-2">Cancel</a>
                <a
                  *ngIf="notifications.length > 0"
                  [routerLink]="['/', eps.notifications.notifications, user?.id]"
                  class="btn btn-primary w-100"
                  >View All</a
                >
              </div>
            </div>
          </div>
          <div class="me-2">
            <!-- <i class="ti ti-brand-hipchat"></i> -->
            <!-- <span
              class="badge bg-info rounded-pill d-flex align-items-center justify-content-center"
              *ngFor="let userRole of user?.userRoles | slice: 0 : 1"
              >{{ userRole.role?.name | addSpace }}</span
            > -->
            <span
              class="badge bg-info rounded-pill d-flex align-items-center justify-content-center"
              >{{ user?.employmentType | addSpace }}</span
            >
          </div>
          <div class="me-2 ms-2">
            <!-- <a href="javascript:void(0)" class="btn btn-menubar position-relative"> -->
            <!-- <i class="ti ti-brand-hipchat"></i> -->

            <span
              class="badge bg-info rounded-pill d-flex align-items-center justify-content-center me-4 ms-2"
              *ngIf="user?.business?.businessName; else noBusiness"
            >
              {{ user?.business?.businessName | capitalize }}
            </span>
            <ng-template #noBusiness>
              <span
                class="badge bg-info rounded-pill d-flex align-items-center justify-content-center me-4"
              >
                N/A
              </span>
            </ng-template>
            <!-- </a> -->
          </div>
          <div class="me-2 ms-2">
            <!-- <span class="avatar avatar-lg me-3 ms-3"> -->
            <!-- <img [src]="businessimageObjectURL" alt="Img" class="img-fluid rounded-circle" /> -->
            <ng-container
              *ngIf="user && user.business && user.business.picture; else businessinitials"
            >
              <ng-container *ngIf="!showBusinessInitials; else businessinitials">
                <span
                  class="avatar avatar-lg rounded-circle d-inline-flex align-items-center justify-content-center text-white"
                >
                  <img
                    [src]="apiEndpoint + '/uploads/' + user.business.picture"
                    (error)="showBusinessInitials = true"
                    alt="Img"
                    class="rounded-circle border border-2"
                    style="
                      width: 36px;
                      height: 36px;
                      object-position: center;
                      object-fit: cover;
                      aspect-ratio: 1 / 1;
                    "
                /></span>
              </ng-container>
            </ng-container>
            <ng-template #businessinitials>
              <span
                class="avatar avatar-sm rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white"
                style="width: 36px; height: 36px"
              >
                {{ getInitials(user?.business?.businessName) }}
              </span>
            </ng-template>
          </div>
          <div class="dropdown profile-dropdown">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle d-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <!-- <span class="avatar avatar-sm online">
                <img [src]="userimageObjectURL" alt="Img" class="img-fluid rounded-circle" />
              </span> -->

              <ng-container *ngIf="userimageObjectURL; else initials">
                <span
                  class="avatar avatar-sm online rounded-circle d-inline-flex align-items-center justify-content-center text-white"
                  style="width: 36px; height: 36px"
                >
                  <img
                    [src]="userimageObjectURL"
                    alt="Img"
                    class="rounded-circle border border-2"
                    style="width: 36px; height: 36px; object-fit: cover; aspect-ratio: 1 / 1"
                /></span>
              </ng-container>
              <ng-template #initials>
                <span
                  class="avatar avatar-sm online d-inline-flex align-items-center justify-content-center bg-primary text-white"
                  style="
                    width: 32px;
                    height: 32px;
                    min-width: 32px;
                    min-height: 32px;
                    max-width: 32px;
                    max-height: 32px;
                    border-radius: 50%;
                  "
                >
                  {{ getInitials(user?.firstName, user?.lastName) }}
                </span>
              </ng-template>
            </a>
            <div class="dropdown-menu shadow-none">
              <div class="card mb-0">
                <div class="card-header">
                  <div class="d-flex align-items-center">
                    <ng-container *ngIf="userimageObjectURL; else initials">
                      <img
                        [src]="userimageObjectURL"
                        alt="Img"
                        class="rounded-circle border border-2"
                        style="
                          width: 40px;
                          height: 40px;
                          object-fit: cover;
                          border-radius: 50%;
                          display: block;
                          object-fit: cover;
                          aspect-ratio: 1 / 1;
                        "
                      />
                    </ng-container>
                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 32px; height: 32px"
                      >
                        {{ getInitials(user?.firstName, user?.lastName) }}
                      </span>
                    </ng-template>
                    <div style="margin-left: 10px">
                      <h5 class="mb-0">{{ user?.firstName }} {{ user?.lastName }}</h5>
                      <!-- <p class="fs-12 fw-medium mb-0">
                        <a
                          *ngIf="user?.email"
                          href="mailto:{{ user?.email }}"
                          class="__cf_email__"
                          data-cfemail="c6b1a7b4b4a3a886a3bea7abb6aaa3e8a5a9ab"
                          >{{ user?.email }}</a
                        >
                      </p> -->
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <a
                    class="dropdown-item d-inline-flex align-items-center p-0"
                    [routerLink]="['/hrm/employee', user?.id]"
                    role="button"
                  >
                    <i class="ti ti-user-circle me-1"></i>My Profile
                  </a>
                  <a
                    href="javascript:void(0)"
                    class="dropdown-item d-inline-flex align-items-center p-0 py-2"
                    (click)="revert()"
                    *ngIf="isImpersonating"
                    ><i class="ti ti-user-share me-1"></i>Switch Back</a
                  >
                  <a
                    class="dropdown-item d-inline-flex align-items-center p-0 py-2 d-none"
                    href="bussiness-settings.html"
                  >
                    <i class="ti ti-settings me-1"></i>Settings
                  </a>

                  <a
                    class="dropdown-item d-inline-flex align-items-center p-0 py-2 d-none"
                    href="profile-settings.html"
                  >
                    <i class="ti ti-circle-arrow-up me-1"></i>My Account
                  </a>
                  <a
                    class="dropdown-item d-inline-flex align-items-center p-0 py-2 d-none"
                    href="knowledgebase.html"
                  >
                    <i class="ti ti-question-mark me-1"></i>Knowledge Base
                  </a>
                </div>
                <div class="card-footer">
                  <a
                    class="dropdown-item d-inline-flex align-items-center p-0"
                    href="javascript:void(0)"
                    (click)="logout()"
                  >
                    <i class="ti ti-login me-2"></i>Logout
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:void(0);"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa fa-ellipsis-v"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-end">
        <a class="dropdown-item" [routerLink]="['/hrm/employee', user?.id]">My Profile</a>
        <a
          href="javascript:void(0)"
          class="dropdown-item"
          (click)="revert()"
          *ngIf="isImpersonating"
          >Switch Back</a
        >
        <!-- <a class="dropdown-item" href="profile-settings.html">Settings</a> -->
        <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
</div>
<!-- /Header -->

<!-- Sidebar -->
<div class="sidebar" id="sidebar">
  <!-- Logo -->
  <div class="sidebar-logo">
    <a href="index.html" class="logo logo-normal">
      <img src="assets/img/logo/logo.webp" alt="Logo" />
    </a>
    <a href="index.html" class="logo-small">
      <img src="assets/img/logo/logo-small.webp" alt="Logo" />
    </a>
    <a href="index.html" class="dark-logo">
      <img src="assets/img/logo/logo-white.webp" alt="Logo" />
    </a>
  </div>
  <!-- /Logo -->
  <!-- <div class="modern-profile p-3 pb-0">
    <div class="text-center rounded bg-light p-3 mb-4 user-profile">
      <div class="avatar avatar-lg online mb-3">
        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle" />
      </div>
      <h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
      <p class="fs-10">System Admin</p>
    </div>
    <div class="sidebar-nav mb-3">
      <ul
        class="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
        role="tablist"
      >
        <li class="nav-item"><a class="nav-link active border-0" href="javascript:void(0)">Menu</a></li>
        <li class="nav-item"><a class="nav-link border-0" href="chat.html">Chats</a></li>
        <li class="nav-item"><a class="nav-link border-0" href="email.html">Inbox</a></li>
      </ul>
    </div>
  </div>
  <div class="sidebar-header p-3 pb-0 pt-2">
    <div class="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
      <div class="avatar avatar-md onlin">
        <img src="assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle" />
      </div>
      <div class="text-start sidebar-profile-info ms-2">
        <h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
        <p class="fs-10">System Admin</p>
      </div>
    </div>
    <div class="input-group input-group-flat d-inline-flex mb-4">
      <span class="input-icon-addon">
        <i class="ti ti-search"></i>
      </span>
      <input type="text" class="form-control" placeholder="Search in HRMS" />
      <span class="input-group-text">
        <kbd>CTRL + / </kbd>
      </span>
    </div>
    <div class="d-flex align-items-center justify-content-between menu-item mb-3">
      <div class="me-3">
        <a href="calendar.html" class="btn btn-menubar">
          <i class="ti ti-layout-grid-remove"></i>
        </a>
      </div>
      <div class="me-3">
        <a href="chat.html" class="btn btn-menubar position-relative">
          <i class="ti ti-brand-hipchat"></i>
          <span
            class="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span
          >
        </a>
      </div>
      <div class="me-3 notification-item">
        <a href="activity.html" class="btn btn-menubar position-relative me-1">
          <i class="ti ti-bell"></i>
          <span class="notification-status-dot"></span>
        </a>
      </div>
      <div class="me-0">
        <a href="email.html" class="btn btn-menubar">
          <i class="ti ti-message"></i>
        </a>
      </div>
    </div>
  </div> -->
  <div class="sidebar-inner slimscroll">
    <div id="sidebar-menu" class="sidebar-menu">
      <ul>
        <li class="menu-title"><span>MAIN MENU</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);" class="active subdrop">
                <i class="ti ti-smart-home"></i>
                <span>Dashboard</span>
                <span class="badge badge-danger fs-10 fw-medium text-white p-1">Hot</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="index.html" class="active">Admin Dashboard</a></li>
                <li><a href="employee-dashboard.html">Employee Dashboard</a></li>
                <li><a href="deals-dashboard.html">Deals Dashboard</a></li>
                <li><a href="leads-dashboard.html">Leads Dashboard</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-layout-grid-add"></i><span>Applications</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="chat.html">Chat</a></li>
                <li class="submenu submenu-two">
                  <a href="call.html">Calls<span class="menu-arrow inside-submenu"></span></a>
                  <ul>
                    <li><a href="voice-call.html">Voice Call</a></li>
                    <li><a href="video-call.html">Video Call</a></li>
                    <li><a href="outgoing-call.html">Outgoing Call</a></li>
                    <li><a href="incoming-call.html">Incoming Call</a></li>
                    <li><a href="call-history.html">Call History</a></li>
                  </ul>
                </li>
                <li><a href="calendar.html">Calendar</a></li>
                <li><a href="email.html">Email</a></li>
                <li><a href="todo.html">To Do</a></li>
                <li><a href="notes.html">Notes</a></li>
                <li><a href="social-feed.html">Social Feed</a></li>
                <li><a href="file-manager.html">File Manager</a></li>
                <li><a href="kanban-view.html">Kanban</a></li>
                <li><a href="invoices.html">Invoices</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0)">
                <i class="ti ti-user-star"></i><span>Super Admin</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="dashboard.html">Dashboard</a></li>
                <li><a href="companies.html">Companies</a></li>
                <li><a href="subscription.html">Subscriptions</a></li>
                <li><a href="packages.html">Packages</a></li>
                <li><a href="domain.html">Domain</a></li>
                <li><a href="purchase-transaction.html">Purchase Transaction</a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>LAYOUT</span></li>
        <li>
          <ul>
            <li>
              <a href="layout-horizontal.html">
                <i class="ti ti-layout-navbar"></i><span>Horizontal</span>
              </a>
            </li>
            <li>
              <a href="layout-detached.html">
                <i class="ti ti-details"></i><span>Detached</span>
              </a>
            </li>
            <li>
              <a href="layout-modern.html">
                <i class="ti ti-layout-board-split"></i><span>Modern</span>
              </a>
            </li>
            <li>
              <a href="layout-two-column.html">
                <i class="ti ti-columns-2"></i><span>Two Column </span>
              </a>
            </li>
            <li>
              <a href="layout-hovered.html">
                <i class="ti ti-column-insert-left"></i><span>Hovered</span>
              </a>
            </li>
            <li>
              <a href="layout-box.html">
                <i class="ti ti-layout-align-middle"></i><span>Boxed</span>
              </a>
            </li>
            <li>
              <a href="layout-horizontal-single.html">
                <i class="ti ti-layout-navbar-inactive"></i><span>Horizontal Single</span>
              </a>
            </li>
            <li>
              <a href="layout-horizontal-overlay.html">
                <i class="ti ti-layout-collage"></i><span>Horizontal Overlay</span>
              </a>
            </li>
            <li>
              <a href="layout-horizontal-box.html">
                <i class="ti ti-layout-board"></i><span>Horizontal Box</span>
              </a>
            </li>
            <li>
              <a href="layout-horizontal-sidemenu.html">
                <i class="ti ti-table"></i><span>Menu Aside</span>
              </a>
            </li>
            <li>
              <a href="layout-vertical-transparent.html">
                <i class="ti ti-layout"></i><span>Transparent</span>
              </a>
            </li>
            <li>
              <a href="layout-without-header.html">
                <i class="ti ti-layout-sidebar"></i><span>Without Header</span>
              </a>
            </li>
            <li>
              <a href="layout-rtl.html">
                <i class="ti ti-text-direction-rtl"></i><span>RTL</span>
              </a>
            </li>
            <li>
              <a href="layout-dark.html"> <i class="ti ti-moon"></i><span>Dark</span> </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>PROJECTS</span></li>
        <li>
          <ul>
            <li>
              <a href="clients-grid.html">
                <i class="ti ti-users-group"></i><span>Clients</span>
              </a>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-box"></i><span>Projects</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="projects-grid.html">Projects</a></li>
                <li><a href="tasks.html">Tasks</a></li>
                <li><a href="task-board.html">Task Board</a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>CRM</span></li>
        <li>
          <ul>
            <li>
              <a href="contacts-grid.html">
                <i class="ti ti-user-shield"></i><span>Contacts</span>
              </a>
            </li>
            <li>
              <a href="companies-grid.html">
                <i class="ti ti-building"></i><span>Companies</span>
              </a>
            </li>
            <li>
              <a href="deals-grid.html">
                <i class="ti ti-heart-handshake"></i><span>Deals</span>
              </a>
            </li>
            <li>
              <a href="leads-grid.html"> <i class="ti ti-user-check"></i><span>Leads</span> </a>
            </li>
            <li>
              <a href="pipeline.html">
                <i class="ti ti-timeline-event-text"></i><span>Pipeline</span>
              </a>
            </li>
            <li>
              <a href="analytics.html"> <i class="ti ti-graph"></i><span>Analytics</span> </a>
            </li>
            <li>
              <a href="activity.html"> <i class="ti ti-activity"></i><span>Activities</span> </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>HRM</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-users"></i><span>Employees</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="employees.html">Employee Lists</a></li>
                <li><a href="employees-grid.html">Employee Grid</a></li>
                <li><a href="employee-details.html">Employee Details</a></li>
                <li><a href="departments.html">Departments</a></li>
                <li><a href="designations.html">Designations</a></li>
                <li><a href="policy.html">Policies</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-ticket"></i><span>Tickets</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="tickets.html">Tickets</a></li>
                <li><a href="ticket-details.html">Ticket Details</a></li>
              </ul>
            </li>
            <li>
              <a href="holidays.html">
                <i class="ti ti-calendar-event"></i><span>Holidays</span>
              </a>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-file-time"></i><span>Attendance</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Leaves<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="leaves.html">Leaves (Admin)</a></li>
                    <li><a href="leaves-employee.html">Leave (Employee)</a></li>
                    <li><a href="leave-settings.html">Leave Settings</a></li>
                  </ul>
                </li>
                <li><a href="attendance-admin.html">Attendance (Admin)</a></li>
                <li><a href="attendance-employee.html">Attendance (Employee)</a></li>
                <li><a href="timesheets.html">Timesheets</a></li>
                <li><a href="schedule-timing.html">Shift & Schedule</a></li>
                <li><a href="overtime.html">Overtime</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-school"></i><span>Performance</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="performance-indicator.html">Performance Indicator</a></li>
                <li><a href="performance-review.html">Performance Review</a></li>
                <li><a href="performance-appraisal.html">Performance Appraisal</a></li>
                <li><a href="goal-tracking.html">Goal List</a></li>
                <li><a href="goal-type.html">Goal Type</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-edit"></i><span>Training</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="training.html">Training List</a></li>
                <li><a href="trainers.html">Trainers</a></li>
                <li><a href="training-type.html">Training Type</a></li>
              </ul>
            </li>
            <li>
              <a href="promotion.html">
                <i class="ti ti-speakerphone"></i><span>Promotion</span>
              </a>
            </li>
            <li>
              <a href="resignation.html">
                <i class="ti ti-external-link"></i><span>Resignation</span>
              </a>
            </li>
            <li>
              <a href="termination.html">
                <i class="ti ti-circle-x"></i><span>Termination</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>RECRUITMENT</span></li>
        <li>
          <ul>
            <li>
              <a href="job-grid.html"> <i class="ti ti-timeline"></i><span>Jobs</span> </a>
            </li>
            <li>
              <a href="candidates-grid.html">
                <i class="ti ti-user-shield"></i><span>Candidates</span>
              </a>
            </li>
            <li>
              <a href="refferals.html"> <i class="ti ti-ux-circle"></i><span>Referrals</span> </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>FINANCE & ACCOUNTS</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-shopping-cart-dollar"></i><span>Sales</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="estimates.html">Estimates</a></li>
                <li><a href="invoices.html">Invoices</a></li>
                <li><a href="payments.html">Payments</a></li>
                <li><a href="expenses.html">Expenses</a></li>
                <li><a href="provident-fund.html">Provident Fund</a></li>
                <li><a href="taxes.html">Taxes</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-file-dollar"></i><span>Accounting</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="categories.html">Categories</a></li>
                <li><a href="budgets.html">Budgets</a></li>
                <li><a href="budget-expenses.html">Budget Expenses</a></li>
                <li><a href="budget-revenues.html">Budget Revenues</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-cash"></i><span>Payroll</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="employee-salary.html">Employee Salary</a></li>
                <li><a href="payslip.html">Payslip</a></li>
                <li><a href="payroll.html">Payroll Items</a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>ADMINISTRATION</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-cash"></i><span>Assets</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="assets.html">Assets</a></li>
                <li><a href="asset-categories.html">Asset Categories</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-headset"></i><span>Help & Supports</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="knowledgebase.html">Knowledge Base</a></li>
                <li><a href="activity.html">Activities</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-user-star"></i><span>User Management</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="users.html">Users</a></li>
                <li><a href="roles-permissions.html">Roles & Permissions</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-user-star"></i><span>Reports</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="expenses-report.html">Expense Report</a></li>
                <li><a href="invoice-report.html">Invoice Report</a></li>
                <li><a href="payment-report.html">Payment Report</a></li>
                <li><a href="project-report.html">Project Report</a></li>
                <li><a href="task-report.html">Task Report</a></li>
                <li><a href="user-report.html">User Report</a></li>
                <li><a href="employee-report.html">Employee Report</a></li>
                <li><a href="payslip-report.html">Payslip Report</a></li>
                <li><a href="attendance-report.html">Attendance Report</a></li>
                <li><a href="leave-report.html">Leave Report</a></li>
                <li><a href="daily-report.html">Daily Report</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-settings"></i><span>Settings</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >General Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="profile-settings.html">Profile</a></li>
                    <li><a href="security-settings.html">Security</a></li>
                    <li><a href="notification-settings.html">Notifications</a></li>
                    <li><a href="connected-apps.html">Connected Apps</a></li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Website Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="bussiness-settings.html">Business Settings</a></li>
                    <li><a href="seo-settings.html">SEO Settings</a></li>
                    <li><a href="localization-settings.html">Localization</a></li>
                    <li><a href="prefixes.html">Prefixes</a></li>
                    <li><a href="preferences.html">Preferences</a></li>
                    <li><a href="performance-appraisal.html">Appearance</a></li>
                    <li><a href="language.html">Language</a></li>
                    <li><a href="authentication-settings.html">Authentication</a></li>
                    <li><a href="ai-settings.html">AI Settings</a></li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >App Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="salary-settings.html">Salary Settings</a></li>
                    <li><a href="approval-settings.html">Approval Settings</a></li>
                    <li><a href="invoice-settings.html">Invoice Settings</a></li>
                    <li><a href="leave-type.html">Leave Type</a></li>
                    <li><a href="custom-fields.html">Custom Fields</a></li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >System Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="email-settings.html">Email Settings</a></li>
                    <li><a href="email-template.html">Email Templates</a></li>
                    <li><a href="sms-settings.html">SMS Settings</a></li>
                    <li><a href="sms-template.html">SMS Templates</a></li>
                    <li><a href="otp-settings.html">OTP</a></li>
                    <li><a href="gdpr.html">GDPR Cookies</a></li>
                    <li><a href="maintenance-mode.html">Maintenance Mode</a></li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Financial Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="payment-gateways.html">Payment Gateways</a></li>
                    <li><a href="tax-rates.html">Tax Rate</a></li>
                    <li><a href="currencies.html">Currencies</a></li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Other Settings<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="custom-css.html">Custom CSS</a></li>
                    <li><a href="custom-js.html">Custom JS</a></li>
                    <li><a href="cronjob.html">Cronjob</a></li>
                    <li><a href="storage-settings.html">Storage</a></li>
                    <li><a href="ban-ip-address.html">Ban IP Address</a></li>
                    <li><a href="backup.html">Backup</a></li>
                    <li><a href="clear-cache.html">Clear Cache</a></li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>CONTENT</span></li>
        <li>
          <ul>
            <li>
              <a href="pages.html"> <i class="ti ti-box-multiple"></i><span>Pages</span> </a>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-brand-blogger"></i><span>Blogs</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="blogs.html">All Blogs</a></li>
                <li><a href="blog-categories.html">Categories</a></li>
                <li><a href="blog-comments.html">Comments</a></li>
                <li><a href="blog-tags.html">Blog Tags</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-map-pin-check"></i><span>Locations</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="countries.html">Countries</a></li>
                <li><a href="states.html">States</a></li>
                <li><a href="cities.html">Cities</a></li>
              </ul>
            </li>
            <li>
              <a href="testimonials.html">
                <i class="ti ti-message-2"></i><span>Testimonials</span>
              </a>
            </li>
            <li>
              <a href="faq.html"> <i class="ti ti-question-mark"></i><span>FAQ’S</span> </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>PAGES</span></li>
        <li>
          <ul>
            <li>
              <a href="starter.html"> <i class="ti ti-layout-sidebar"></i><span>Starter</span> </a>
            </li>
            <li>
              <a href="profile.html"> <i class="ti ti-user-circle"></i><span>Profile</span> </a>
            </li>
            <li>
              <a href="gallery.html"> <i class="ti ti-photo"></i><span>Gallery</span> </a>
            </li>
            <li>
              <a href="search-result.html">
                <i class="ti ti-list-search"></i><span>Search Results</span>
              </a>
            </li>
            <li>
              <a href="timeline.html"> <i class="ti ti-timeline"></i><span>Timeline</span> </a>
            </li>
            <li>
              <a href="pricing.html"> <i class="ti ti-file-dollar"></i><span>Pricing</span> </a>
            </li>
            <li>
              <a href="coming-soon.html">
                <i class="ti ti-progress-bolt"></i><span>Coming Soon</span>
              </a>
            </li>
            <li>
              <a href="under-maintenance.html">
                <i class="ti ti-alert-octagon"></i><span>Under Maintenance</span>
              </a>
            </li>
            <li>
              <a href="under-construction.html">
                <i class="ti ti-barrier-block"></i><span>Under Construction</span>
              </a>
            </li>
            <li>
              <a href="api-keys.html"> <i class="ti ti-api"></i><span>API Keys</span> </a>
            </li>
            <li>
              <a href="privacy-policy.html">
                <i class="ti ti-file-description"></i><span>Privacy Policy</span>
              </a>
            </li>
            <li>
              <a href="terms-condition.html">
                <i class="ti ti-file-check"></i><span>Terms & Conditions</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>AUTHENTICATION</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-login"></i><span>Login</span><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="login.html">Cover</a></li>
                <li><a href="login-2.html">Illustration</a></li>
                <li><a href="login-3.html">Basic</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-forms"></i><span>Register</span><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="register.html">Cover</a></li>
                <li><a href="register-2.html">Illustration</a></li>
                <li><a href="register-3.html">Basic</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-help-triangle"></i><span>Forgot Password</span
                ><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="forgot-password.html">Cover</a></li>
                <li><a href="forgot-password-2.html">Illustration</a></li>
                <li><a href="forgot-password-3.html">Basic</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-restore"></i><span>Reset Password</span
                ><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="reset-password.html">Cover</a></li>
                <li><a href="reset-password-2.html">Illustration</a></li>
                <li><a href="reset-password-3.html">Basic</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-mail-exclamation"></i><span>Email Verification</span
                ><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="email-verification.html">Cover</a></li>
                <li><a href="email-verification-2.html">Illustration</a></li>
                <li><a href="email-verification-3.html">Basic</a></li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-password"></i><span>2 Step Verification</span
                ><span class="menu-arrow"></span>
              </a>
              <ul>
                <li><a href="two-step-verification.html">Cover</a></li>
                <li><a href="two-step-verification-2.html">Illustration</a></li>
                <li><a href="two-step-verification-3.html">Basic</a></li>
              </ul>
            </li>
            <li>
              <a href="lock-screen.html"
                ><i class="ti ti-lock-square"></i><span>Lock Screen</span></a
              >
            </li>
            <li>
              <a href="error-404.html"><i class="ti ti-error-404"></i><span>404 Error</span></a>
            </li>
            <li>
              <a href="error-500.html"><i class="ti ti-server"></i><span>500 Error</span></a>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>UI INTERFACE</span></li>
        <li>
          <ul>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-hierarchy-2"></i>
                <span>Base UI</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="ui-alerts.html">Alerts</a>
                </li>
                <li>
                  <a href="ui-accordion.html">Accordion</a>
                </li>
                <li>
                  <a href="ui-avatar.html">Avatar</a>
                </li>
                <li>
                  <a href="ui-badges.html">Badges</a>
                </li>
                <li>
                  <a href="ui-borders.html">Border</a>
                </li>
                <li>
                  <a href="ui-buttons.html">Buttons</a>
                </li>
                <li>
                  <a href="ui-buttons-group.html">Button Group</a>
                </li>
                <li>
                  <a href="ui-breadcrumb.html">Breadcrumb</a>
                </li>
                <li>
                  <a href="ui-cards.html">Card</a>
                </li>
                <li>
                  <a href="ui-carousel.html">Carousel</a>
                </li>
                <li>
                  <a href="ui-colors.html">Colors</a>
                </li>
                <li>
                  <a href="ui-dropdowns.html">Dropdowns</a>
                </li>
                <li>
                  <a href="ui-grid.html">Grid</a>
                </li>
                <li>
                  <a href="ui-images.html">Images</a>
                </li>
                <li>
                  <a href="ui-lightbox.html">Lightbox</a>
                </li>
                <li>
                  <a href="ui-media.html">Media</a>
                </li>
                <li>
                  <a href="ui-modals.html">Modals</a>
                </li>
                <li>
                  <a href="ui-offcanvas.html">Offcanvas</a>
                </li>
                <li>
                  <a href="ui-pagination.html">Pagination</a>
                </li>
                <li>
                  <a href="ui-popovers.html">Popovers</a>
                </li>
                <li>
                  <a href="ui-progress.html">Progress</a>
                </li>
                <li>
                  <a href="ui-placeholders.html">Placeholders</a>
                </li>
                <li>
                  <a href="ui-spinner.html">Spinner</a>
                </li>
                <li>
                  <a href="ui-sweetalerts.html">Sweet Alerts</a>
                </li>
                <li>
                  <a href="ui-nav-tabs.html">Tabs</a>
                </li>
                <li>
                  <a href="ui-toasts.html">Toasts</a>
                </li>
                <li>
                  <a href="ui-tooltips.html">Tooltips</a>
                </li>
                <li>
                  <a href="ui-typography.html">Typography</a>
                </li>
                <li>
                  <a href="ui-video.html">Video</a>
                </li>
                <li>
                  <a href="ui-sortable.html">Sortable</a>
                </li>
                <li>
                  <a href="ui-swiperjs.html">Swiperjs</a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-hierarchy-3"></i>
                <span>Advanced UI</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="ui-ribbon.html">Ribbon</a>
                </li>
                <li>
                  <a href="ui-clipboard.html">Clipboard</a>
                </li>
                <li>
                  <a href="ui-drag-drop.html">Drag & Drop</a>
                </li>
                <li>
                  <a href="ui-rangeslider.html">Range Slider</a>
                </li>
                <li>
                  <a href="ui-rating.html">Rating</a>
                </li>
                <li>
                  <a href="ui-text-editor.html">Text Editor</a>
                </li>
                <li>
                  <a href="ui-counter.html">Counter</a>
                </li>
                <li>
                  <a href="ui-scrollbar.html">Scrollbar</a>
                </li>
                <li>
                  <a href="ui-stickynote.html">Sticky Note</a>
                </li>
                <li>
                  <a href="ui-timeline.html">Timeline</a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-input-search"></i>
                <span>Forms</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Form Elements <span class="menu-arrow inside-submenu"></span>
                  </a>
                  <ul>
                    <li>
                      <a href="form-basic-inputs.html">Basic Inputs</a>
                    </li>
                    <li>
                      <a href="form-checkbox-radios.html">Checkbox & Radios</a>
                    </li>
                    <li>
                      <a href="form-input-groups.html">Input Groups</a>
                    </li>
                    <li>
                      <a href="form-grid-gutters.html">Grid & Gutters</a>
                    </li>
                    <li>
                      <a href="form-select.html">Form Select</a>
                    </li>
                    <li>
                      <a href="form-mask.html">Input Masks</a>
                    </li>
                    <li>
                      <a href="form-fileupload.html">File Uploads</a>
                    </li>
                  </ul>
                </li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Layouts <span class="menu-arrow inside-submenu"></span>
                  </a>
                  <ul>
                    <li>
                      <a href="form-horizontal.html">Horizontal Form</a>
                    </li>
                    <li>
                      <a href="form-vertical.html">Vertical Form</a>
                    </li>
                    <li>
                      <a href="form-floating-labels.html">Floating Labels</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="form-validation.html">Form Validation</a>
                </li>

                <li>
                  <a href="form-select2.html">Select2</a>
                </li>
                <li>
                  <a href="form-wizard.html">Form Wizard</a>
                </li>
                <li>
                  <a href="form-pickers.html">Form Picker</a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-table-plus"></i>
                <span>Tables</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="tables-basic.html">Basic Tables </a>
                </li>
                <li>
                  <a href="data-tables.html">Data Table </a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-chart-line"></i>
                <span>Charts</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="chart-apex.html">Apex Charts</a>
                </li>
                <li>
                  <a href="chart-c3.html">Chart C3</a>
                </li>
                <li>
                  <a href="chart-js.html">Chart Js</a>
                </li>
                <li>
                  <a href="chart-morris.html">Morris Charts</a>
                </li>
                <li>
                  <a href="chart-flot.html">Flot Charts</a>
                </li>
                <li>
                  <a href="chart-peity.html">Peity Charts</a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-icons"></i>
                <span>Icons</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="icon-fontawesome.html">Fontawesome Icons</a>
                </li>
                <li>
                  <a href="icon-tabler.html">Tabler Icons</a>
                </li>
                <li>
                  <a href="icon-bootstrap.html">Bootstrap Icons</a>
                </li>
                <li>
                  <a href="icon-remix.html">Remix Icons</a>
                </li>
                <li>
                  <a href="icon-feather.html">Feather Icons</a>
                </li>
                <li>
                  <a href="icon-ionic.html">Ionic Icons</a>
                </li>
                <li>
                  <a href="icon-material.html">Material Icons</a>
                </li>
                <li>
                  <a href="icon-pe7.html">Pe7 Icons</a>
                </li>
                <li>
                  <a href="icon-simpleline.html">Simpleline Icons</a>
                </li>
                <li>
                  <a href="icon-themify.html">Themify Icons</a>
                </li>
                <li>
                  <a href="icon-weather.html">Weather Icons</a>
                </li>
                <li>
                  <a href="icon-typicon.html">Typicon Icons</a>
                </li>
                <li>
                  <a href="icon-flag.html">Flag Icons</a>
                </li>
              </ul>
            </li>
            <li class="submenu">
              <a href="javascript:void(0);">
                <i class="ti ti-table-plus"></i>
                <span>Maps</span>
                <span class="menu-arrow"></span>
              </a>
              <ul>
                <li>
                  <a href="maps-vector.html">Vector</a>
                </li>
                <li>
                  <a href="maps-leaflet.html">Leaflet</a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="menu-title"><span>Extras</span></li>
        <li>
          <ul>
            <li>
              <a href="javascript:void(0);"
                ><i class="ti ti-file-text"></i><span>Documentation</span></a
              >
            </li>
            <li>
              <a href="javascript:void(0);"
                ><i class="ti ti-exchange"></i><span>Changelog</span
                ><span class="badge bg-pink badge-xs text-white fs-10 ms-s">v4.0.2</span></a
              >
            </li>
            <li class="submenu">
              <a href="javascript:void(0);"
                ><i class="ti ti-menu-2"></i><span>Multi Level</span><span class="menu-arrow"></span
              ></a>
              <ul>
                <li><a href="javascript:void(0);">Multilevel 1</a></li>
                <li class="submenu submenu-two">
                  <a href="javascript:void(0);"
                    >Multilevel 2<span class="menu-arrow inside-submenu"></span
                  ></a>
                  <ul>
                    <li><a href="javascript:void(0);">Multilevel 2.1</a></li>
                    <li class="submenu submenu-two submenu-three">
                      <a href="javascript:void(0);"
                        >Multilevel 2.2<span
                          class="menu-arrow inside-submenu inside-submenu-two"
                        ></span
                      ></a>
                      <ul>
                        <li><a href="javascript:void(0);">Multilevel 2.2.1</a></li>
                        <li><a href="javascript:void(0);">Multilevel 2.2.2</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li><a href="javascript:void(0);">Multilevel 3</a></li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- /Sidebar -->
